import { Link } from 'react-router-dom';
import './PanchangLinks.scss';

const PanchangLinks = () => {
  return (
    <div className="panchang-links">
      <h2>Panchang Links</h2>
      <div className="card-grid">

        <Link to="/panchang/dainik" className="card">
          <div className="img-part">
            <img
              src="https://bcdn.mpanchang.com/images/social/panchang.jpg"
              alt="Daily Panchang"
            />
          </div>
          <div className="text-part">
            <h3>Daily Panchang</h3>
            <p>This is the daily Panchang detail that includes Tithi, Nakshatra, Yoga, and Karana.</p>
          </div>
        </Link>

        <Link to="/panchang/monthly" className="card">
          <div className="img-part">
            <img
              src="https://bcdn.mpanchang.com/images/social/panchang.jpg"
              alt="Monthly Panchang"
            />
          </div>
          <div className="text-part">
            <h3>Monthly Panchang</h3>
            <p>Overview of all important days in a month including festivals and vrats.</p>
          </div>
        </Link>

        <Link to="/panchang/bengali" className="card">
          <div className="img-part">
            <img
              src="https://bcdn.mpanchang.com/images/social/panchang.jpg"
              alt="Bengali Panchang"
            />
          </div>
          <div className="text-part">
            <h3>Bengali Panjika</h3>
            <p>Important festivals, fasts and astrological events of the whole year.</p>
          </div>
        </Link>

        <Link to="/panchang/english" className="card">
          <div className="img-part">
            <img
              src="https://bcdn.mpanchang.com/images/social/panchang.jpg"
              alt="English Timings"
            />
          </div>
          <div className="text-part">
            <h3>English panjika</h3>
            <p>Find out exact sunrise, sunset, moonrise, and moonset timings.</p>
          </div>
        </Link>

        <Link to="/panchang/iskcon" className="card">
          <div className="img-part">
            <img
              src="https://bcdn.mpanchang.com/images/social/panchang.jpg"
              alt="Iskcon"
            />
          </div>
          <div className="text-part">
            <h3>Vaishnav</h3>
            <p>Use Panchang to match horoscopes based on birth details.</p>
          </div>
        </Link>

        <Link to="/panchang/chandrabalam" className="card">
          <div className="img-part">
            <img
              src="https://bcdn.mpanchang.com/images/social/panchang.jpg"
              alt="Chandrabalam"
            />
          </div>
          <div className="text-part">
            <h3>Chandrabalam</h3>
            <p>Find the best Muhurat for marriage, housewarming, and other events.</p>
          </div>
        </Link>

        <Link to="/panchang/naksatra" className="card">
          <div className="img-part">
            <img
              src="https://bcdn.mpanchang.com/images/social/panchang.jpg"
              alt="Chandrabalam"
            />
          </div>
          <div className="text-part">
            <h3>Tara</h3>
            <p>Find the best Muhurat for marriage, housewarming, and other events.</p>
          </div>
        </Link>

      </div>
    </div>
  );
};

export default PanchangLinks;
